<template>
    <div class="full-height pa-3" id="meeting_participant">
        
        <!-- VIDEO GRID -->
        <v-row v-if="meeting.is_connected && (!show_aux_track || isSharingScreen()) && !meeting.isCobrowsing() && !meeting.is_whiteboard_active">
            <v-col :cols="getValOrBlankCols(index)" v-for="(peer, index) in video_peers" 
                :key="peer.id"
                :class="'pa-2 ' + getValOrBlankColClass(index)"
            >
                <v-card :loading="loading_video_plugin && peer.isLocal" class="rounded-lg"
                    v-if="meeting.local_peer.roleName != 'waiting-room' || peer.isLocal"
                >
                    <video 
                        v-if="meeting.peer_video_enabled[peer.id]"
                        :aspect-ratio="16/9"
                        autoplay 
                        :muted="peer.isLocal" 
                        playsinline 
                        :ref="peer.id"
                        style="max-width:100%;width:100%;object-fit:cover;margin-bottom:-6px;"
                        :class="`rounded-lg ${grid[index] ? grid[index].class : ''} ${peer.isLocal ? ' mirror' : ''}`"
                    ></video>
                    <v-card v-else style="max-width:100%; margin-bottom:-6px;">
                        <v-responsive :aspect-ratio="16/9" :class="`rounded-lg ${grid[index] ? grid[index].class : ''}`">
                            <div class="fill-height" style="width: 100%; display: flex; align-items: center; justify-content: center;">
                                <span class="text-h4 font-weight-bold">{{ peer.name }}</span>
                            </div>
                        </v-responsive>
                    </v-card>
                    <!-- <v-overlay v-if="peer.roleName == 'host'" opacity="0" :absolute="true" style="justify-content:start;align-items:start;">
                        <v-img v-if="app.room && app.room.settings.header_logo != ''" :src="app.room.settings.header_logo" max-height="40" contain />
                    </v-overlay> -->
                    <v-overlay opacity="0" :absolute="true" style="justify-content:start;align-items:end;">
                        <v-chip class="mx-2 white--text mb-2" :color="`${peer.roleName == 'coach' ? 'orange' : 'grey'} darken-4`" small>
                            {{peer.name}} 
                            <span v-if="meeting.local_peer.roleName != 'guest'" class="ml-1">({{peer.roleName.toUpperCase()}})</span>
                            <v-btn class="ml-1 white--text" icon x-small @click="['host', 'coach'].includes(meeting.local_peer.roleName) && meeting.enablePeerAudio(peer, !meeting.peer_audio_enabled[peer.id])">
                                <v-icon v-if="!meeting.peer_audio_enabled[peer.id]" color="red">mdi-microphone-off</v-icon>
                                <v-icon v-else>mdi-microphone</v-icon>
                            </v-btn>
                            <!-- VIDEO MENU -->
                            <meeting-participant-menu :peer="peer" v-if="meeting.permissions && meeting.permissions.changeRole"></meeting-participant-menu>
                        </v-chip>
                    </v-overlay>

                    <!-- ADMIT FROM WAITING ROOM BUTTON -->
                    <v-overlay :absolute="true" :value="peer.roleName == 'waiting-room' && ['host','coach'].includes(meeting.local_peer.roleName)">
                        <v-btn v-if="meeting.local_peer.roleName == 'host'" color="primary" x-large @click="meeting.hmsActions.changeRole(peer.id, 'guest', true);">
                            Admit {{peer.name.toUpperCase()}}
                        </v-btn>
                    </v-overlay>
                </v-card>
            </v-col>

        </v-row>
        

        <!-- SCREENSHARE LAYOUT -->
        <v-container v-if="show_aux_track && !isSharingScreen()" fluid class="mt-0 full-height pa-0">
            <v-row dense>
                <v-col cols="2">
                    <v-card v-for="peer in video_peers" :key="peer.id" class="rounded-lg mb-2">
                        <video
                            :aspect-ratio="16/9"
                            autoplay 
                            :muted="peer.isLocal" 
                            playsinline 
                            :ref="peer.id"
                            style="width:100%;object-fit:cover;margin-bottom:-6px;"
                            :class="`rounded-lg video-sixth-height ${peer.isLocal ? ' mirror' : ''}`"
                        ></video>
                        <v-overlay :absolute="true" v-if="meeting.is_connected" opacity="0" style="justify-content:start;align-items:end;">
                            <v-chip class="ma-1 white--text" :color="`${peer.roleName == 'coach' ? 'orange' : 'grey'} darken-4`" small>
                                {{peer.name}} 
                                <v-icon v-if="!meeting.peer_audio_enabled[peer.id]" class="ml-2" color="red">mdi-microphone-off</v-icon>
                            </v-chip>
                        </v-overlay>
                        <!-- ADMIT FROM WAITING ROOM BUTTON -->
                        <v-overlay :absolute="true" v-if="peer.roleName == 'waiting-room' && ['host','coach'].includes(meeting.local_peer.roleName)">
                            <v-btn v-if="meeting.local_peer.roleName == 'host'" x-small color="primary" @click="meeting.hmsActions.changeRole(peer.id, 'guest', true);">
                                Admit {{peer.name.toUpperCase()}}
                            </v-btn>
                        </v-overlay>
                    </v-card>
                </v-col>
                <v-col cols="10">
                    <div>
                        <video 
                            :aspect-ratio="16/9"
                            autoplay 
                            playsinline 
                            ref="screenshare_video"
                            style="max-width:100%;width:100%;object-fit:contain;margin-bottom:-36px;"
                            :class="`rounded-lg video-full-height`"
                        ></video>
                    </div>
                </v-col>
            </v-row>
        </v-container>

        <!-- LIVESTREAM LAYOUT -->
        <v-container v-if="meeting.isLivestreaming && meeting.local_peer && meeting.local_peer.roleName == 'livestream-viewer'" fluid class="mt-0 full-height pa-0">
            <v-row dense>
                <v-col cols="12">
                    <video 
                        :aspect-ratio="16/9"
                        autoplay 
                        playsinline 
                        ref="livestream_video"
                        style="max-width:100%;width:100%;object-fit:contain;margin-bottom:-36px;"
                        :class="`video-full-height`"
                    ></video>
                </v-col>
            </v-row>
        </v-container>


        <!-- COBROWSE LAYOUT -->
        <v-container v-if="meeting.is_connected && meeting.cobrowse_session && meeting.isCobrowsing()" fluid class="mt-0 full-height pa-0">
            <v-row dense>
                <v-col cols="2">
                    <v-card v-for="peer in video_peers" :key="peer.id" class="rounded-lg mb-2">
                        <video
                            :aspect-ratio="16/9"
                            autoplay 
                            :muted="peer.isLocal" 
                            playsinline 
                            :ref="peer.id"
                            style="width:100%;object-fit:cover;margin-bottom:-6px;"
                            :class="`rounded-lg video-sixth-height ${peer.isLocal ? ' mirror' : ''}`"
                        ></video>
                        <v-overlay :absolute="true" v-if="meeting.is_connected" opacity="0" style="justify-content:start;align-items:end;">
                            <v-chip class="ma-1 white--text" :color="`${peer.roleName == 'coach' ? 'orange' : 'grey'} darken-4`" small>
                                {{peer.name}} 
                                <v-icon v-if="!meeting.peer_audio_enabled[peer.id]" class="ml-2" color="red">mdi-microphone-off</v-icon>
                            </v-chip>
                        </v-overlay>
                        <!-- ADMIT FROM WAITING ROOM BUTTON -->
                        <v-overlay :absolute="true" v-if="peer.roleName == 'waiting-room' && ['host','coach'].includes(meeting.local_peer.roleName)">
                            <v-btn v-if="meeting.local_peer.roleName == 'host'" x-small color="primary" @click="meeting.hmsActions.changeRole(peer.id, 'guest', true);">
                                Admit {{peer.name.toUpperCase()}}
                            </v-btn>
                        </v-overlay>
                    </v-card>
                </v-col>
                <v-col cols="10">
                    <iframe
                        class="video-full-height rounded-lg"
                        style="width:100%;margin-bottom:-36px;"
                        :src="meeting.local_peer.roleName == 'host' ? meeting.cobrowse_session.leader_link+'?name='+meeting.local_peer.name : meeting.cobrowse_session.follower_link+'?name='+meeting.local_peer.name"
                        allow="autoplay *; display-capture *; geolocation *;"
                    >
                    </iframe>
                    
                </v-col>
            </v-row>
            
        </v-container>
        
        
        <!-- WHITEBOARD LAYOUT -->
        <v-container v-if="meeting.is_connected && meeting.is_whiteboard_active" fluid class="mt-0 full-height pa-0">
            <v-row dense>
                <v-col cols="2">
                    <v-card v-for="peer in video_peers" :key="peer.id" class="rounded-lg mb-2">
                        <video
                            :aspect-ratio="16/9"
                            autoplay 
                            :muted="peer.isLocal" 
                            playsinline 
                            :ref="peer.id"
                            style="width:100%;object-fit:cover;margin-bottom:-6px;"
                            :class="`rounded-lg video-sixth-height ${peer.isLocal ? ' mirror' : ''}`"
                        ></video>
                        <v-overlay :absolute="true" v-if="meeting.is_connected" opacity="0" style="justify-content:start;align-items:end;">
                            <v-chip class="ma-1 white--text" :color="`${peer.roleName == 'coach' ? 'orange' : 'grey'} darken-4`" small>
                                {{peer.name}} 
                                <v-icon v-if="!meeting.peer_audio_enabled[peer.id]" class="ml-2" color="red">mdi-microphone-off</v-icon>
                            </v-chip>
                        </v-overlay>
                        <!-- ADMIT FROM WAITING ROOM BUTTON -->
                        <v-overlay :absolute="true" v-if="peer.roleName == 'waiting-room' && ['host','coach'].includes(meeting.local_peer.roleName)">
                            <v-btn v-if="meeting.local_peer.roleName == 'host'" x-small color="primary" @click="meeting.hmsActions.changeRole(peer.id, 'guest', true);">
                                Admit {{peer.name.toUpperCase()}}
                            </v-btn>
                        </v-overlay>
                    </v-card>
                </v-col>
                <v-col cols="10">
                    <div class="video-full-height rounded-lg" style="width:100%;margin-bottom:-36px;" id="wt-container"></div>
                </v-col>
            </v-row>
        </v-container>

        <v-overlay :value="meeting.is_connected && meeting.local_peer && ['coach','qa'].includes(meeting.local_peer.roleName) && meeting.isCobrowsing()" :absolute="true" opacity="0"></v-overlay>

    </div>
</template>

<script>
// import axios from 'axios'
import { useAppStore } from '../stores/app'
import { useUserStore } from '../stores/user'
import { useMeetingStore } from '../stores/meeting'
import Hls from 'hls.js'

import {
  HMSReactiveStore,
  selectIsLocalVideoEnabled,
  selectIsLocalScreenShared,
  selectPeers,
  selectIsConnectedToRoom,
  selectLocalPeerRoleName,
  selectLocalPeer,
  selectIsInPreview,
  selectIsPeerAudioEnabled,
  selectIsPeerVideoEnabled,
  selectPeerMetadata,
  selectRTMPState,
  selectAuxiliaryTracksByPeerID,
  selectVideoPlaylist,
  selectAudioPlaylist,
  selectRoomStarted
} from "@100mslive/hms-video-store"
import { setVirtualBackground, HMSVirtualBackgroundPlugin } from '@100mslive/hms-virtual-background'
// import MeetingParticipantMenu from './MeetingParticipantMenu.vue'
// import HostProfile from './HostProfile.vue'
// import { supabase } from '../lib/supabaseClient'

// Initialize HMS Store
const hmsManager = new HMSReactiveStore()
hmsManager.triggerOnSubscribe()
const hmsStore = hmsManager.getStore()
const hmsActions = hmsManager.getActions()
const hmsNotifications = hmsManager.getNotifications()

export default {
    name: 'MeetingRecording',
    components: {
        // MeetingParticipantMenu,
        // HostProfile
    },
    created: function() {
        console.log("meeting participant", this.$route.params)
        this.app = useAppStore()
        this.user = useUserStore()
        this.meeting = useMeetingStore()

        this.name = ''
    },
    data() {
        return {
            app: null,
            user: null,
            meeting: null,
            name: "",
            password: "",
            show_admin_login: false,
            admin_email: "",
            admin_password: "",
            token: null,
            peers: [],
            videoRefs: [],
            isMuted: false,
            videoMuted: false,
            screenshare_peer_id: null,
            show_aux_track: false,
            aux_track: null,
            preview_track: null,
            selected_camera: null,
            selected_microphone: null,
            preview_video_key: 'preview_video_key',
            loading_video_plugin: false,
            grid: [
                { class:'video-half-height', cols:4 },
                { class:'video-half-height', cols:4 },
                { class:'video-half-height', cols:4 },
                { class:'video-half-height', cols:4 },
                { class:'video-half-height', cols:4 },
                { class:'video-half-height', cols:4 },
            ],
            leaving: false,
            joining: false,
            is_logging_in: false,
            show_cobrowse: false,
            selected_room: null,
            presense_channel: null,
            presense: null,
            show_waiting_for_host: true,
            video_playlist_item_paused: false,
            error: null,
            browser: {browser:{name:''}},
            micEnabled: null,
            cameraEnabled: null,
            // rooms: []
        }
    },
    mounted: async function() {

        // console.log("HEY. This is the meeting recording component!?!?!>!")
        let role = 'guest'
        await this.getToken(role)
            
        this.createSubscriptions()

        this.setUpGrid()
        let g = this
        window.onresize = function() {
            g.setUpGrid()
        }

        this.meeting.hmsActions = hmsActions
        this.meeting.hmsStore = hmsStore

        this.handleNotifications()

        // (function(s,u,r,f,l,y){s[f]=s[f]||{init:function(){s[f].q=arguments}};
        // l=u.createElement(r);y=u.getElementsByTagName(r)[0];l.async=1;
        // l.src='https://surfly.com/surfly.js';y.parentNode.insertBefore(l,y);})
        // (window,document,'script','Surfly');

        // var settings = {
        // // Surfly session options can be set here, or at the Company/Plan levels.
        // widget_key: 'b6013a7e576e41549e709b3041f23928',
        // private_session: false, // to make sure only logged in agents can join the calls
        // password_required: false,
        // url: 'https://dialerup.com'
        // };

        // Surfly.init(settings, function(initResult) {
        //     if (initResult.success) {
        //         // API calls can now be made!
        //         if (!Surfly.isInsideSession) {
        //             Surfly.button();
        //         }
        //     }
        //     else{
        //         console.log("Surfly was unable to initialize properly.")
        //     }
        // });
    },
    beforeDestroy() {
        // this.leave()
    },
    computed: {
        video_peers: function() {
            return this.peers.filter(peer => {
                //hide recording beam
                if(['record', 'record-guest', 'qa'].includes(peer.roleName))
                    return false

                if(peer.isLocal)
                    return true

                // if they're in the waiting room, only return their own video
                if(this.meeting?.local_peer?.roleName == 'waiting-room' && !peer.isLocal)
                    return false

                // if this isn't the recording beam and this user is not a guest, then show the video feed
                if(this.meeting?.local_peer?.roleName !== 'guest' && this.meeting?.local_peer?.roleName !== 'waiting-room')
                    return true
                
                //is a guest
                if(['guest', 'host'].includes(peer.roleName))
                    return true

                return false
            })
            // return this.peers.filter(peer => this.meeting.peer_video_enabled[peer.id])
        },
    },
    methods: {
        createSubscriptions: function() {
            hmsStore.subscribe(this.renderPeers, selectPeers)
            hmsStore.subscribe(connected => this.meeting.is_connected = connected, selectIsConnectedToRoom)
            hmsStore.subscribe(peer => this.meeting.local_peer = peer, selectLocalPeer)
            hmsStore.subscribe(screen_shared => this.meeting.is_local_screen_shared = screen_shared, selectIsLocalScreenShared)
            hmsStore.subscribe(livestream_state => this.meeting.livestream_state = livestream_state, selectRTMPState);
            hmsStore.subscribe(video_playlist => this.meeting.video_playlist = video_playlist, selectVideoPlaylist.list);
            hmsStore.subscribe(audio_playlist => this.meeting.audio_playlist = audio_playlist, selectAudioPlaylist.list);
            hmsStore.subscribe(room_started => this.meeting.room_started = room_started, selectRoomStarted);
        },
        handleNotifications: function() {
            let unsubscribe = hmsNotifications.onNotification(async (notification) => {
                console.log('NOTIFICATION (rec1):', notification.type, notification);
                switch(notification.type) {
                    case 'METADATA_UPDATED':
                        const metadata = JSON.parse(notification.data.metadata)
                        this.meeting.isScreenSharingEnabled = metadata.isScreenSharingEnabled ? metadata.isScreenSharingEnabled[this.meeting.local_peer.id] : false
                        this.meeting.cobrowse_session = metadata.cobrowse_session
                        this.meeting.whiteboard_code = metadata.whiteboard_code
                        if(metadata.whiteboard_code && metadata.whiteboard_code != "") {
                            console.log("whiteboard_code:", metadata.whiteboard_code)
                            this.meeting.is_whiteboard_active = true
                            this.meeting.activateWhiteboard()
                        } else {
                            this.meeting.is_whiteboard_active = false
                        }
                        if(metadata.room) {
                            this.app.room = metadata.room
                        }
                        break
                    case 'TRACK_UNMUTED':
                        this.renderPeers()
                        break
                    case 'ROOM_ENDED':
                    case 'REMOVED_FROM_ROOM':
                        // this.meeting.presence_channel.untrack()
                        this.meeting.leaving = true
                        break
                    case 'NEW_MESSAGE':
                        if(notification?.data?.type == "STOP_RECORDING") {
                            console.log("stop the recording now")
                            this.meeting.stopRecording()
                        }
                        break;
                    case 'PEER_LEFT':
                        if(this.peers.length == 1) {
                            this.meeting.stopRecording()
                            break
                        }
                        break
                }
            });
        },
        getValOrBlankColClass: function(index) {

            return this?.grid[index]?.col_class ?? ''
        },
        getValOrBlankCols: function(index) {
            return this?.grid[index]?.cols ?? ''
        },
        userIsGuest: function() {
            return this.meeting?.local_peer?.roleName == 'guest'
        },
        getToken: function(role = 'guest') {
            console.log("getting token")
            var g = this
            var identity = "Recording Beam"
            var url = "meeting/token"

            var data = {
                room_id: this.app.room_id
            }

            data.role = this.$route.params.role
            
            return g.app.post(url, data).then(async response => {
                g.token = response.data.token
                // CANT GET LIST OF PEERS UNTIL AFTER YOU JOIN THE MEETING
                // //prevent multiple recording peers from joining
                // let recording_peers = 0
                // console.log('check for recording peers', g.meeting.peers)
                // g.meeting.peers.forEach(peer => {
                //     console.log("prejoin roleName", peer.roleName, peer.roleName.indexOf('record'))
                //     if(peer.roleName.indexOf('record') > -1)
                //         recording_peers++
                // })
                // console.log("recording_peers", recording_peers)
                // if(recording_peers >= 1)
                //     return
                await g.join()
            })
        },
        inPreview: function(isInPreview) {
            this.is_in_preview = isInPreview 
            if(isInPreview)
                this.$nextTick(() => {
                    if(this.meeting.local_peer && this.meeting.local_peer.videoTrack && this.$refs.preview_video) {
                        this.toggleVideo(true)
                        hmsActions.attachVideo(this.meeting.local_peer.videoTrack, this.$refs.preview_video)
                    }
                })
                
        },
        onConnection: function(isConnected) {
            this.meeting.is_connected = isConnected
        },
        join: async function() {
            this.meeting.leaving = false
            window.localStorage.setItem('meeting_display_name', this.name)

            if(this.app.room.settings.password || this.userIsGuest()) {
                let g = this
                this.app.post('meeting/check-password', { room_id: this.app.room.ID, password: this.password })
                .then(async response => {
                    g.joining = true
                    await hmsActions.join({
                        userName: this.name,
                        authToken: this.token
                    })
                    g.joining = false
                })
                .catch(error => {
                    this.app.showError('Login failed')
                    this.lists.loading = false
                })
            } else {
                this.joining = true
                await hmsActions.join({
                    userName: this.name,
                    authToken: this.token
                })

                // console.log("joined")
                this.joining = false
            }

        },
        renderPeers: function(peers) {
            this.setUpGrid()
            if(hmsStore.getState(selectIsInPreview)) {
                return
            }
            
            if(peers && peers.length > 0) {
                this.peers = peers
                this.meeting.peers = peers
            }
            

            // listen for mute/unmute of audio/video
            let g = this
            this.peers.forEach(peer => {
                hmsStore.subscribe(enabled => this.$set(this.meeting.peer_audio_enabled, peer.id, enabled), selectIsPeerAudioEnabled(peer.id))
                hmsStore.subscribe(function(enabled) {
                    g.$set(g.meeting.peer_video_enabled, peer.id, enabled)
                    // g.setUpGrid()
                }, selectIsPeerVideoEnabled(peer.id))
            })

            // this.video_peers = this.peers.filter(peer => {
            //     return hmsStore.getState(selectIsPeerVideoEnabled(peer.id))
            // })

            //after dom updates, attach the video tracks
            this.$nextTick(() => {
                this.peers.forEach(peer => {
                    if(peer?.videoTrack) {
                        if(this.$refs[peer.id] && this.$refs[peer.id].length) {
                            hmsActions.attachVideo(peer.videoTrack, this.$refs[peer.id][0])
                        } else if(!this.meeting.leaving && peer.videoTrack && this.$refs[peer.id]) {
                            console.log("the peer", peer, peer.videoTrack)
                            if(peer?.videoTrack)
                                hmsActions.attachVideo(peer.videoTrack, this.$refs[peer.id])
                        }
                    }
                })
            })
            //screenshare
            this.show_aux_track = false
            this.aux_track = null
            this.peers.forEach(peer => {
                if(peer.auxiliaryTracks.length > 0) {

                    const tracks = this.meeting.hmsStore.getState(selectAuxiliaryTracksByPeerID(peer.id))
                    tracks.forEach(track => {
                        if(track.type == 'video'){
                            this.show_aux_track = true
                            this.show_video_playlist_item = true
                            this.aux_track = peer.auxiliaryTracks[1] ?? peer.auxiliaryTracks[0]
                            this.$nextTick((peer) => {
                                hmsActions.attachVideo(this.aux_track, this.$refs.screenshare_video)
                            })
                        }
                    })
                }
            })  
        },
        toggleVideo: function(on) {
            if(on) {
                hmsActions.setLocalVideoEnabled(on)
                this.videoMuted = on
            } else {
                const videoEnabled = !hmsStore.getState(selectIsLocalVideoEnabled)
                hmsActions.setLocalVideoEnabled(videoEnabled)
                this.videoMuted = !videoEnabled
            }
            this.$nextTick(() => {
                this.renderPeers()
            })
        },
        showVideoTile: function(peer) {
            let localRoleName = hmsStore.getState(selectLocalPeerRoleName)
            return true
        },
        isSharingScreen: function() {
            return hmsStore.getState(selectIsLocalScreenShared)
        },
        testBtn: function() {
            let is_sharing = hmsStore.getState(selectIsLocalScreenShared)
        },
        // getScreenShare: function() {
        //     let screenshare = hmsStore.getState(selectScreenShareByPeerID(this.screenshare_peer_id))
        //     hmsActions.attachVideo(screenshare, this.$refs.screenshare_video)
        // },
        virtualBackgroundIsSupported: function( ) {
            this.virtual_background = new HMSVirtualBackgroundPlugin()
            const pluginSupport = hmsActions.validateVideoPluginSupport(this.virtual_background);
            if (pluginSupport.isSupported) {
                return true
            } else {
                const err = pluginSupport.errMsg;
                console.error(err);
                return false
            }
        },
        setUpGrid: function() {
            let count = this.video_peers.length

            //creating a spot for a host placeholder in the waiting room
            if(this.meeting?.local_peer?.roleName == 'waiting-room')
                count = 2
            
            var grid = [];

            if(count == 1) {
                grid[0] = { class:'video-full-height', cols:12 }
            }
            else if(count == 2) {
                grid = Array.from({length: 2}, (_, index) => {return { class:'video-full-height', cols:6}})
            }
            else if(count == 3) {
                grid = Array.from({length: 3}, (_, index) => {return { class:'video-full-height', cols:4 }})
            }
            else if(count == 4) {
                grid = Array.from({length: 4}, (_, index) => {return { class:'video-half-height', cols:6 }})
            }
            else if(count == 5) {
                grid = Array.from({length: count}, (_, index) => {return { class:'video-half-height', cols:4 }})
            }
            else if(count == 6) {
                grid = Array.from({length: 6}, (_, index) => {return { class:'video-half-height', cols:4 }})
            }             
            else if(count == 7) {
                grid = Array.from({length: 4}, (_, index) => {return { class:'video-third-height', cols:6 }})
                grid[4] = { class:'video-third-height', cols:4 }
                grid[5] = { class:'video-third-height', cols:4 }
                grid[6] = { class:'video-third-height', cols:4 }
            }
            else if(count == 8) {
                grid = Array.from({length: 6}, (_, index) => {return { class:'video-third-small-height', cols:4 }})
                grid[6] = { class:'video-third-large-height', cols:6 }
                grid[7] = { class:'video-third-large-height', cols:6 }
            }
            else if(count == 9){
                grid = Array.from({length: count}, (_, index) => {return { class:'video-third-height', cols:4 }})
            }
            else if(count > 9 && count <=12 ) {
                grid = Array.from({length: count}, (_, index) => {return { class:'video-fourth-height', cols:4 }})
            }
            else if(count >= 13 && count <= 16) {
                grid = Array.from({length: count}, (_, index) => {return { class:'video-fourth-height', cols:3 }})
            }
            else if(count >= 17 && count <= 24) {
                grid = Array.from({length: count}, (_, index) => {return { class:'video-fourth-height', cols:2 }})
            }
            else if(count >= 25) {
                grid = Array.from({length: count}, (_, index) => {return { class:'video-sixth-height', cols:2 }})
            }

            this.grid = grid
            return
        },
    },
    watch: {
        video_peers: {
            handler() {
                this.$nextTick(() => this.renderPeers())
            },
            deep: true
        },
        'app.room.ID': async function(newV) {
            this.app.setUpTheme(this.$vuetify)

            if(!this.meeting.is_connected || !this.meeting.hmsStore)
                return

            //send meeting notification to update current participants
            const metadata = this.meeting.hmsStore.getState(selectPeerMetadata(this.meeting.local_peer.id))
            const newMetadata = { ...metadata, room: this.app.room }
            await this.meeting.hmsActions.changeMetadata(newMetadata)
        },
        'meeting.livestream_state': function(newV) {
            console.log('watch meeting.livestream_state', newV)

            //turn off loading indicators
            if(newV.running)
                this.meeting.rtmp_starting = false
            else
                this.meeting.rtmp_stopping = false

            //TODO: need to refactor this to separate out more clearly RTMP vs Livestream
            if(this.meeting.livestream_state?.running && this.meeting.livestream_state.variants) {
                const hlsUrl = this.meeting.livestream_state.variants[0]?.url
                // const video = document.getElementById('video');
                const video = this.$refs.livestream_video
                const browserHasNativeHLSSupport = video.canPlayType('application/vnd.apple.mpegurl');
                if (Hls.isSupported()) {
                    let hls = new Hls();
                    hls.loadSource(hlsUrl);
                    hls.attachMedia(video);
                    this.$nextTick(() => {
                        // hmsActions.attachVideo(this.aux_track, this.$refs.screenshare_video)
                        hls.attachMedia(video);
                    })
                }
                // hls.js is not supported on iOS Safari, but as the browser has native support for playing HLS,
                // we can use the video element directly.
                else if (browserHasNativeHLSSupport) {
                    video.src = hlsUrl;
                }
            }
        }

    }

}


</script>

<style scoped>
.mirror {
    transform: scaleX(-1);
}
#leave_btn {
    bottom: 15px;
}
.video-full-height {
    height: calc(100vh - 136px);
    max-height: calc(100vh - 136px);
}
.video-two-thirds-height {
    height: calc(67vh - 136px);
    max-height: calc(100vh - 136px);
}
.video-half-height {
    height: calc(50vh - 78px);
    max-height: calc(50vh - 78px);
}
.video-fourth-height {
    height: calc(25vh - 38px);
}
.video-third-small-height {
    height: calc(30vh - 46px);
}
.video-third-large-height {
    height: calc(39vh - 46px);
}
.video-third-height {
    height: calc(33vh - 46px);
}
.video-quarter-height {
    height: calc(25vh - 38px);
}
.video-fifth-height {
    height: calc(20vh - 30px);
}
.video-sixth-height {
    height: calc(16vh - 17px);
}
.video-five-sixths-height {
    height: calc(16vh - 155px);
}
.video-eighth-height {
    height: calc(12vh - 12px);
}
.translate-half {
    transform:translateY(20vh);
}
.translate-third {
    transform:translateY(15vh);
}
.translate-fourth {
    transform:translateY(10vh);
}
</style>
